import { Chart } from 'primereact/chart';
import { useEffect, useState } from "react";
import { BsExclamationCircle } from 'react-icons/bs';
import { FiSearch } from 'react-icons/fi';
import { getSearchLogMetrics } from "../../services/AuthService";
import { showToastError } from "../../utils/common/ToastMessages";
interface popupProps {
  selectedSortOption?: any

}

const SearchMetrics = ({ selectedSortOption }: popupProps) => {
  const [widgtsCount, setWidgtsCount] = useState<any>()
  const [filterBy, setFilterBy] = useState(''); // Default to 'Monthwise'
  const [basicData, setBasicData] = useState<{ labels: string[]; datasets: any[] }>({ labels: [], datasets: [] });
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [topSearchQueries, setTopSearchQueries] = useState<any[]>([]);
  const [rateBarData, setRateBarData] = useState({});
  const [rateBarOptions, setRateBarOptions] = useState({});
  const [DailySearches, setDailySearches] = useState<any[]>([]);

  // TO get all metrics data
  const getSearchMetrics = () => {
    let obj = {
      "timePeriod": selectedSortOption,
    }
    getSearchLogMetrics(obj).then((response: any) => {
      setWidgtsCount(response?.searchLog?.kpis);
      setTopSearchQueries(response?.searchLog?.topQueries || []);
      setDailySearches(response?.searchLog?.dailySearches || []);
    })
      .catch((error: any) => {
        showToastError(error);
      });
  };

  useEffect(() => {
    getSearchMetrics()
  }, [selectedSortOption])

  // Added this useEffect to update top 5 searches
  useEffect(() => {
    if (topSearchQueries && topSearchQueries.length > 0) {
      setChartData({
        labels: topSearchQueries.map((item: any) => item.query),
        datasets: [
          {
            label: 'Query',
            data: topSearchQueries.map((item: any) => item.searchCount),
            backgroundColor: 'rgb(23 135 120)',
            borderRadius: 4,
            borderWidth: 1,
            barThickness: 50,
          }
        ]
      });
      setChartOptions({
        responsive: true,
        aspectRatio: 0.5,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              pointStyle: 'oval',
              color: '#000',
              font: {
                size: 14,
                lineHeight: 1.8
              }
            }
          },
          tooltip: {
            enabled: true,
          }
        },
        scales: {
          x: {
            title: {
              display: true,
              // text: 'Query',
            },
            grid: {
              display: false
            },
            ticks: {
              color: '#495057',
              font: {
                size: 14,
                weight: 'bold'
              }
            },
            barPercentage: 0.18,
            categoryPercentage: 0.5
          },
          y: {
            title: {
              display: true,
              text: 'Search Count',
            },
            grid: {
              display: true
            },
            beginAtZero: true,
            ticks: {
              color: '#495057',
              stepSize: 1
            }
          }
        }
      });
    }
  }, [topSearchQueries]);

  // Added this useEffect for Success Rate doughnut chart
  useEffect(() => {
    if (widgtsCount) {
      setRateBarData({
        labels: ['Success Rate', 'No Result'],
        datasets: [
          {
            data: [widgtsCount.successRate, widgtsCount.zeroResultsRate],
            backgroundColor: ['#36A2EB', '#FF6384'], // blue, red
            borderWidth: 2,
          }
        ]
      });
      setRateBarOptions({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              pointStyle: 'oval',
              color: '#495057',
              font: {
                size: 14,

              }
            }
          },
          tooltip: { enabled: true }
        },
        cutout: '60%',
      });
    }
  }, [widgtsCount]);

  // added this useEffect for Daily Searches line chart
  useEffect(() => {
    if (DailySearches && DailySearches.length > 0) {
      const labels = DailySearches.map((item: any) => {
        const date = new Date(item.searchDay);
        return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' }); // e.g., Feb 03
      });
      const data = DailySearches.map((item: any) => item.numberOfSearches);
      setBasicData({
        labels,
        datasets: [
          {
            label: 'Date',
            data,
            fill: false,
            borderColor: '#14b8a6', // teal-500
            // backgroundColor: '#14b8a6',
            tension: 0.4,
            pointBackgroundColor: '#14b8a6',
            pointBorderColor: '#fff',
            pointRadius: 5,
          }
        ]
      });
    }
  }, [widgtsCount]);

  // Optionally, update basicOptions for better visuals:
  const basicOptions = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'oval',
          color: '#14b8a6',
          font: {
            size: 14,

          }
        }
      }
    },
    scales: {
      x: {
        ticks: { color: '#495057', font: { size: 12, weight: 'bold' } },
      },
      y: {
        title: { display: true, text: 'Number of Searches' },
        beginAtZero: true,
        ticks: { color: '#495057' },
      }
    }
  };

  return (
    <div className="container-fluid ps-0">
      <div className="d-flex  mt-3 row d-flex">
        <div className="col-md-4" >
          <div className="bg-white rounded-md border shadow-md p-3">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold text-primary text-xl">{widgtsCount?.totalSearches}</h5>
              <span className="w-[40px] h-[40px] bg-secondary bg-opacity-25 p-2 d-flex justify-content-center align-items-center rounded-circle"><FiSearch size={20} /></span>
            </div>
            <div>  <h6 className="fw-bold mb-1">Total Searches </h6></div>
            <span className=""><span style={{ color: '#14b8a6' }}>{widgtsCount?.totalSearchesChangePercent} </span>   from last month</span>
          </div>

        </div>
        <div className="col-md-4" >
          <div className="bg-white rounded-md border shadow-md p-3">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold text-primary text-xl">{widgtsCount?.zeroResultsRate} %</h5>
              <span className="w-[40px] h-[40px] bg-secondary bg-opacity-25 p-2 d-flex justify-content-center align-items-center rounded-circle"><BsExclamationCircle size={20} /></span>
            </div>
            <div>  <h6 className="fw-bold mb-1">Zero Result Rate </h6></div>
            <span className=""> <span style={{ color: ' #FF6384' }}> {widgtsCount?.zeroResultsChangePercent}  </span> from last month</span>
          </div>
        </div>
        <div className="col-md-4" >
          <div className="bg-white rounded-md border shadow-md p-3">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold text-primary text-xl">{widgtsCount?.successRate} %</h5>
              <span className="w-[40px] h-[40px] bg-secondary bg-opacity-25 p-2 d-flex justify-content-center align-items-center rounded-circle"><BsExclamationCircle size={20} /></span>
            </div>
            <div>  <h6 className="fw-bold mb-1"> Success Rate</h6></div>
            <span className=""> <span style={{ color: '#36A2EB' }}>  {widgtsCount?.successChangePercent} </span> from last month</span>
          </div>
        </div>
      </div>

      <div className=" my-3">
        <div className="row">
          <div className="col">
            <div className="bg-white p-3 shadow-md border rounded-md">
              <h5 className="fw-bold d-flex mb-4">Daily Searches</h5>
              <Chart
                type="line"
                key={filterBy}
                data={basicData && basicData.labels && basicData.datasets ? basicData : { labels: [], datasets: [] }}
                options={basicOptions}
                style={{ height: '400px', width: '100%' }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="my-3">
        <div className="row">
          <div className="col-md-8">
            <div className="bg-white p-3 shadow-md border rounded-md pb-0 ">
              <div className="d-flex justify-content-between mb-4">
                <h5 className="fw-bold mb-0">Top 5 Search Queries</h5>
              </div>
              <div className=" overflow-y-auto overflow-x-hidden">
                <div className="bg-white p-3 ">
                  <Chart type="bar" data={chartData} options={chartOptions} style={{ height: '400px', width: '100%' }} />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="bg-white p-3 shadow-md border rounded-md justify-content-end">
              <h5 className="fw-bold d-flex mb-4">Success Rate</h5>
              <div style={{ height: '417px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Chart type="pie" data={rateBarData} options={rateBarOptions} style={{ height: '400px', width: '320px' }} />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default SearchMetrics;
